export const MIXPANEL_RECORD_SESSION_PERCENT = 25;

export const MIXPANEL_RECORD_SESSION_PERCENT_GUEST = 2;

/**
 * Experiments which are tracked 100% of the time
 * Add your experiment number here, if it exists in layout_abtests package import the number from there
 */
export const FULLY_TRACKED_EXPERIMENTS = {
    CHEETAHS_BOOK_PUBLISHING: 5142,
    ANACONDAS_LTS: 5132,
};
